import { Location } from '@angular/common';
import { Inject, Injectable } from "@angular/core";
import {
	AccountInfo, AuthenticationResult, AuthorizationUrlRequest, EndSessionRequest, IPublicClientApplication, PopupRequest,
	RedirectRequest,
	SilentRequest
} from "@azure/msal-browser";
import { from, Observable, of } from 'rxjs';
import { MSAL_INSTANCE } from "./constants";
import { IMsalService } from "./IMsalService";

@Injectable()
export class MsalService implements IMsalService {
	private readonly redirectHash: string;
	private interactionInProgress = false;

	constructor(
		@Inject(MSAL_INSTANCE) public instance: IPublicClientApplication,
		private readonly location: Location
	) {
		// Cache the code hash before Angular router clears it
		const hash = this.location.path(true).split('#').pop();
		console.info("HASH", this.location.path(true).split('#'))
		if (hash) {
			this.redirectHash = `#${hash}`;
			console.info("this.redirectHash", this.redirectHash)
		}
	}

	acquireTokenPopup(request: PopupRequest): Observable<AuthenticationResult> {
		return from(this.instance.acquireTokenPopup(request));
	}
	acquireTokenRedirect(request: RedirectRequest): Observable<void> {
		if (this.hasActiveInteraction()) {
			console.warn('MSAL interaction already in progress. Skipping acquireTokenRedirect call.');
			return of(undefined);
		}
		this.interactionInProgress = true;
		return from(this.instance.acquireTokenRedirect(request));
	}
	acquireTokenSilent(silentRequest: SilentRequest): Observable<AuthenticationResult> {
		return from(this.instance.acquireTokenSilent(silentRequest));
	}
	getAccountByUsername(userName: string): AccountInfo {
		return this.instance.getAccountByUsername(userName);
	}
	getAllAccounts(): AccountInfo[] {
		return this.instance.getAllAccounts();
	}
	handleRedirectObservable(): Observable<AuthenticationResult> {
		return from(this.instance.handleRedirectPromise(this.redirectHash));
	}
	loginPopup(request?: PopupRequest): Observable<AuthenticationResult> {
		return from(this.instance.loginPopup(request));
	}
	loginRedirect(request?: RedirectRequest): Observable<void> {
		if (this.hasActiveInteraction()) {
			console.warn('MSAL interaction already in progress. Skipping loginRedirect call.');
			return of(undefined);
		}
		this.interactionInProgress = true;
		return from(this.instance.loginRedirect(request));
	}
	logout(logoutRequest?: EndSessionRequest): Observable<void> {
		return from(this.instance.logout(logoutRequest));
	}
	ssoSilent(request: AuthorizationUrlRequest): Observable<AuthenticationResult> {
		return from(this.instance.ssoSilent(request));
	}

	private hasActiveInteraction(): boolean {
		if (this.interactionInProgress) {
			return true;
		}

		const interactionKeys = ['msal.interaction.status'];
		for (const key of Object.keys(sessionStorage)) {
			if (key.endsWith('.interaction.status')) {
				interactionKeys.push(key);
			}
		}

		return interactionKeys.some((key) => sessionStorage.getItem(key) === 'interaction_in_progress');
	}

}
